import { type Cell } from '@tanstack/react-table';
import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';

export const progressMapAtom = atom<Record<string, boolean>>({});

export const selectedCellAtom = atomWithDefault<Cell<any, any>>(() => null);
